import { useMemo } from 'react';
import { FEATURE_SAVED_SEARCHES } from 'App/features';
import { ORDERS_SAVED_SEARCHES } from 'config/upsellFlowSources';
import useUpsellFlow, {
  UpsellResultEnum,
} from 'domains/Billing/UpsellFlow/hooks/useUpsellFlow';
import { useSavedSearches } from 'domains/Orders/components/SavedSearches';
import { trackingCreateSavedSearchUpsell } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

export function useSavedSearchesUpsell(
  callback: () => void,
  onClose?: () => void,
) {
  const t = useTranslationOrders();
  const { savedSearches } = useSavedSearches();
  const currentSavedSearchesCount = useMemo(
    () => savedSearches.filter((ss) => !ss.isDefault).length,
    [savedSearches],
  );

  return useUpsellFlow({
    title: t('savedSearches.upsellTitle'),
    featureKey: FEATURE_SAVED_SEARCHES,
    trackingSource: ORDERS_SAVED_SEARCHES,
    minValue: currentSavedSearchesCount + 1,
    includeCallbackResult: true,
    onPlansRedirect: () => {
      trackingCreateSavedSearchUpsell(UpsellResultEnum.PLANS_REDIRECT);
    },
    callback: (upsellResult) => {
      trackingCreateSavedSearchUpsell(upsellResult);
      callback();
      onClose?.();
    },
    onCloseModal: (upsellResult) => {
      if (upsellResult === UpsellResultEnum.DECLINED) {
        trackingCreateSavedSearchUpsell(upsellResult);
      }
      onClose?.();
    },
  });
}
